import React from 'react';
import './Reference.scss';

function Reference() {
  return (
    <div className="reference">
      <p className="reference__copy">
        <sup className="reference__sup">1</sup> Among those who have a preference
      </p>

      <p className="reference__copy">
        <sup className="reference__sup">2</sup> Enfamil is a brand from Mead Johnson, now part of
        the Reckitt group of companies.
      </p>
    </div>
  );
}

export default Reference;
